import React from 'react';
import '../css/NotFound.css';
import { Link } from 'react-router-dom';
import { FaTerminal } from 'react-icons/fa6';

const NotFound = () => {
  return (
    <div className="NotFound-root">
      <div className="NotFound-container">
        <div className="warning-hud font-mono">
          <div className="hud-header">
            <span className="hud-dot red"></span>
            <span className="hud-title">SYSTEM ALERT // ERROR 404</span>
          </div>
          <div className="hud-body">
            <h3 className="NotFound-h3 font-title">UNRESOLVED ROUTE</h3>
            <p className="NotFound-p">
              The address requested does not resolve to an active node in the XChip directory.
            </p>
            <div className="terminal-code font-mono">
              <span className="text-red">> ERROR_CODE: ERR_ADDR_NOT_FOUND</span>
              <span>> RESOLUTION: RE-ROUTE TO GATEWAY</span>
            </div>
            <Link to="/" className="NotFound-btn font-mono">
              <FaTerminal />
              <span>EXECUTE HOME_REDIRECT.SH</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
